import React from 'react';
import { LayoutGrid, List, RectangleHorizontal } from 'lucide-react';
import { InventaireViewMode } from '../utils/inventaireViewMode';

interface ViewModeControlsProps {
  viewMode: InventaireViewMode;
  onViewModeChange: (mode: InventaireViewMode) => void;
}

const viewModes: Array<{
  key: InventaireViewMode;
  label: string;
  shortLabel: string;
  icon: React.ReactNode;
}> = [
  { key: 'liste', label: 'Liste', shortLabel: 'Liste', icon: <List className="h-4 w-4" /> },
  {
    key: 'card-grid',
    label: 'Grille',
    shortLabel: 'Grille',
    icon: <LayoutGrid className="h-4 w-4" />,
  },
  {
    key: 'card-full',
    label: 'Pleine largeur',
    shortLabel: 'Large',
    icon: <RectangleHorizontal className="h-4 w-4" />,
  },
];

const ViewModeControls: React.FC<ViewModeControlsProps> = ({ viewMode, onViewModeChange }) => {
  return (
    <div className="flex items-center gap-2 min-w-0">
      <span className="text-sm text-gray-700 font-medium hidden sm:inline">Affichage</span>
      <div className="flex border border-gray-300 rounded-md overflow-hidden shrink-0">
        {viewModes.map((mode) => (
          <button
            key={mode.key}
            type="button"
            onClick={() => onViewModeChange(mode.key)}
            className={`inline-flex items-center gap-1.5 px-2.5 sm:px-3 py-2 text-sm font-medium transition-colors ${
              viewMode === mode.key
                ? 'bg-blue-600 text-white'
                : 'bg-white text-gray-700 hover:bg-gray-50'
            }`}
            title={mode.label}
            aria-pressed={viewMode === mode.key}
            aria-label={mode.label}
          >
            {mode.icon}
            <span className="hidden sm:inline">{mode.shortLabel}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ViewModeControls;
